import { render } from "./SeStdTaxFormLossesExpenses.vue?vue&type=template&id=646dc1d8"
import script from "./SeStdTaxFormLossesExpenses.vue?vue&type=script&lang=js"
export * from "./SeStdTaxFormLossesExpenses.vue?vue&type=script&lang=js"

import "./SeStdTaxFormLossesExpenses.vue?vue&type=style&index=0&id=646dc1d8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__